import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import { WarningPopUp, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { handleApiError } from "@utils/errorHandler";
import editIcon from "@icons/ic-edit-blue.svg";
import moreIcon from "@icons/ic-more.svg";
import redoAgain from "@icons/ic-activate-blue.svg";
import redo from "@icons/ic-activate-grey.svg";
import SiteStatus from "../../../SiteList/components/SiteStatus";
import communicationIcon from "@icons/ic-communication.svg";
import DiscussionList from "../../../../Discussion/DiscussionList/DiscussionList";
import { labelStyles, DivToolTip } from "@utils/extra-style";
import {
  SyncIconWrapper,
  SyncSpinnerPosition,
  SyncSuccessMessage,
} from "@shared/styles/common.styled";
import {
  GridRow,
  ProductTitle,
  ButtonWrapper,
  ParentDetail,
  CommunicationButtonWrapper,
} from "../../SiteView.styled";

import { MoreDropdownMenu } from "./Header.styled";
import "./Header.scss";

const Header = (props) => {
  const { t, siteData, setSiteData, setIsRefeshData } = props;
  const params = useParams();
  const history = useNavigate();
  const [communicationBox, setCommunicationBox] = useState(false);

  const [isSyncRunning, setIsSyncingRunning] = useState(false);
  const [syncSuccess, setSyncSuccess] = useState(false);
  const [isDisplayMore, setIsDisplayMore] = useState(false);
  const [lostReason, setLostReason] = useState("");
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [selectedCompanyStep, setCompanyStep] = useState(0);
  const [selectedCompanyStepLabel, setCompanyStepLabel] = useState("");

  const stepActionData = {
    1: [
      {
        label: "SITE_ACTION_CANCEL",
        value: 10,
      },
      {
        label: "SITE_ACTION_PENDING",
        value: 9,
      },
    ],

    2: [
      {
        label: "SITE_ACTION_LOST_HESUS",
        value: 4,
      },
      {
        label: "SITE_ACTION_LOST_CLIENT",
        value: 5,
      },
    ],

    9: [
      {
        label: "SITE_ACTION_QUOTATION",
        value: 1,
      },
      {
        label: "SITE_ACTION_QUOTE_SENT",
        value: 2,
      },
      {
        label: "SITE_ACTION_CANCEL",
        value: 10,
      },
    ],

    11: [
      {
        label: "SITE_ACTION_CANCEL",
        value: 10,
      },
    ],
    13: [
      {
        label: "SITE_ACTION_PAUSED",
        value: 14,
      },
      {
        label: "SITE_ACTION_FINISHED",
        value: 15,
      },
    ],
    14: [
      {
        label: "SITE_ACTION_CANCEL",
        value: 10,
      },
      {
        label: "SITE_ACTION_LOST_HESUS",
        value: 4,
      },
      {
        label: "SITE_ACTION_IN_PROGRESS",
        value: 13,
      },
    ],
    15: [
      {
        label: "SITE_ACTION_IN_PROGRESS",
        value: 13,
      },
    ],
  };

  const onEdit = () => {
    history(`/site/edit/${siteData.id}`);
  };

  const openCommunicationBox = () => {
    setCommunicationBox(true);
  };
  const onCommunicationBoxCancel = () => {
    setCommunicationBox(false);
  };

  const handleMoreDisplay = () => {
    isDisplayMore ? setIsDisplayMore(false) : setIsDisplayMore(true);
  };

  const onStepChange = (id, label) => {
    if (!isSyncRunning) {
      setCompanyStep(id);
      setCompanyStepLabel(label);
      setConfirmVisibility(true);
    }
  };

  const updateSiteStep = () => {
    const jsonData = {
      previousStepId: siteData.id,
      newStepId: selectedCompanyStep,
      comment: lostReason,
    };
    setIsSyncingRunning(true);
    axios
      .post(`/sites/${siteData.id}/transitionStep`, jsonData)
      .then((response) => {
        setIsDisplayMore(false);
        setSiteData(response?.data[0]);
        setIsSyncingRunning(false);
        setIsRefeshData(true);
      })
      .catch((error) => handleApiError(error));
  };

  const updateSyncStatus = () => {
    if (isSyncRunning) return;
    setIsSyncingRunning(true);
    axios
      .post(`/sites/${siteData.id}/syncOps`)
      .then((response) => {
        setIsSyncingRunning(false);
        setIsRefeshData(true);
        setSyncSuccess(true);
        setTimeout(() => setSyncSuccess(false), 3000);
      })
      .catch((error) => {
        setIsSyncingRunning(false);
        handleApiError(error);
      });
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
  };

  const onPopUpConfirm = () => {
    updateSiteStep();
    setConfirmVisibility(false);
  };

  return (
    <>
      <GridRow column="1fr 1fr" marginBottom="0px" gap="0rem">
        <GridRow column="1fr" gap="0rem" marginBottom="50px">
          <ProductTitle># {siteData.id + " - " + siteData.name} </ProductTitle>
          <ParentDetail>
            {t("SITE_OF")}&nbsp;
            <Link
              className="site-view-header__parent-link"
              to={`/company/view/${siteData.company?.id}/general-info`}
            >
              # {siteData?.company?.id + "-" + siteData?.company?.name}
            </Link>
          </ParentDetail>
        </GridRow>
        <GridRow column="1fr" gap="0rem">
          <ButtonWrapper>
            <SiteStatus data={siteData.status} isActive={1} />

            {params.path === "general-info" && (
              <>
                <Image
                  src={editIcon}
                  alt={t("SITE_ACTION_TOOLTIP_EDIT ")}
                  title={t("SITE_ACTION_TOOLTIP_EDIT ")}
                  className="site-view-header__image-icon"
                  onClick={onEdit}
                />

                {(siteData.isErpSync === 1 ||
                  [3, 12].includes(siteData.status) ||
                  (siteData.needKickoff === 1 &&
                    siteData.platformCountry.needKickoff === 1 &&
                    [2, 3].includes(siteData.koStatus))) && (
                  <SyncIconWrapper>
                    {!isSyncRunning ? (
                      <>
                        <Image
                          src={siteData.isErpSync === 1 ? redoAgain : redo}
                          alt={t("SITE_ACTION_TOOLTIP_REFRESH_OPS")}
                          id={`site-sync-tooltip-id${siteData.id}`}
                          className="site-view-header__image-icon"
                          onClick={updateSyncStatus}
                        />
                        <Tooltip
                          place="top"
                          positionStrategy="fixed"
                          anchorSelect={`#site-sync-tooltip-id${siteData.id}`}
                          noArrow
                          style={DivToolTip}
                          content={t("SITE_ACTION_TOOLTIP_REFRESH_OPS")}
                        />
                      </>
                    ) : (
                      <SyncSpinnerPosition>
                        <ClipLoader size={15} color="#9d9797" />
                      </SyncSpinnerPosition>
                    )}
                    {syncSuccess && (
                      <SyncSuccessMessage>
                        {t("OPS_SYNC_MANUAL_EXECUTED")}
                      </SyncSuccessMessage>
                    )}
                  </SyncIconWrapper>
                )}
                {[1, 2, 9, 11, 13, 14, 15].includes(siteData.status) && (
                  <Image
                    src={moreIcon}
                    alt={t("SITE_ACTION_TOOLTIP_MORE_ACTION")}
                    title={t("SITE_ACTION_TOOLTIP_MORE_ACTION")}
                    className="site-view-header__image-icon"
                    onClick={() => handleMoreDisplay()}
                  />
                )}

                <MoreDropdownMenu display={isDisplayMore ? "block" : "none"}>
                  <ul className="m-0 p-0 flag-dropdown-menu-list">
                    {stepActionData &&
                      stepActionData[siteData.status]?.map((item) => (
                        <li
                          key={item.value}
                          className="dropdown-item more-dropdown-item"
                          onClick={() => {
                            onStepChange(item.value, item.label);
                          }}
                        >
                          {t(item.label)}
                        </li>
                      ))}
                  </ul>
                </MoreDropdownMenu>
              </>
            )}
          </ButtonWrapper>
          <CommunicationButtonWrapper>
            <Image
              src={communicationIcon}
              alt={t("COMMUNICATION")}
              title={t("COMMUNICATION")}
              className="site-view-header__communication-icon"
              onClick={() => openCommunicationBox()}
            />
            {communicationBox && (
              <DiscussionList
                entityType={2}
                entityId={siteData.id}
                onClose={onCommunicationBoxCancel}
              />
            )}
          </CommunicationButtonWrapper>
        </GridRow>
      </GridRow>
      {isConfirmVisible && (
        <WarningPopUp
          title={t("SITE_CONFIRMATION_STEP_CHANGE")}
          message={
            t("SITE_CONFIRMATION_STEP_CHANGE_CONTENT") +
            " : " +
            t(selectedCompanyStepLabel)
          }
          customMessage={lostReason}
          isCustomMessage={[4, 5].includes(selectedCompanyStep)}
          setCustomMessage={setLostReason}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
          customLabel={t("SITE_CONFIRMATION_STEP_CHANGE_TO_LOST")}
          labelStyles={labelStyles}
          containerStyles={{ marginTop: "21px" }}
          inputStyles={{ padding: "7px 5px 7px 10px" }}
        />
      )}
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
